module.exports = __webpack_public_path__ + "img/pageType2.a93e8aef.png";